export type WhatsAppSenderStatus =
  | 'creating'
  | 'draft'
  | 'offline'
  | 'online'
  | 'online_updating'
  | 'pending_verification'
  | 'stubbed'
  | 'twilio_review'
  | 'verifying';

export type WhatsAppSenderState = 'active' | 'in-progress' | 'action-required' | 'problem';

// Registration that never reached Twilio leaves the sender in `creating` forever.
export function canRestartRegistration(
  status: WhatsAppSenderStatus,
  senderSid: string | null,
): boolean {
  return status === 'creating' && senderSid === null;
}

export function resolveSenderState(
  status: WhatsAppSenderStatus,
  senderSid: string | null,
): WhatsAppSenderState {
  if (canRestartRegistration(status, senderSid)) {
    return 'problem';
  }

  switch (status) {
    case 'online':
    case 'online_updating':
      return 'active';
    case 'creating':
    case 'verifying':
    case 'twilio_review':
      return 'in-progress';
    case 'pending_verification':
      return 'action-required';
    default:
      return 'problem';
  }
}
